import React from 'react';
import get from 'lodash/get';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { LINE_ITEM_INITIAL_PAYMENT, propTypes } from '../../util/types';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  txGetPromoLineItem,
  txIsCanceled,
  txIsCanceledByCustomer,
  txIsDeclined,
  txIsDelivered,
} from '../../util/transaction';

import css from './BookingBreakdownNew.css';

const { Money } = sdkTypes;

const LineItemTotalPriceNew = props => {
  const { transaction, isProvider, intl, currentUser, isTripExtension, openInvoicesTotal } = props;

  if (!transaction) {
    return (
      <div className={css.lineItemTotal}>
        <div className={css.totalPrice}>$-</div>
      </div>
    );
  }

  let providerTotalMessageId = 'BookingBreakdown.providerTotalDefault';
  if (txIsDelivered(transaction)) {
    providerTotalMessageId = 'BookingBreakdown.providerTotalDelivered';
  } else if (txIsDeclined(transaction)) {
    providerTotalMessageId = 'BookingBreakdown.providerTotalDeclined';
  } else if (txIsCanceled(transaction)) {
    providerTotalMessageId = 'BookingBreakdown.providerTotalCanceled';
  }

  const isLongTermRental = get(transaction, 'attributes.protectedData.isLongTermRental');
  const totalLabel = isProvider ? (
    <FormattedMessage id={providerTotalMessageId} />
  ) : isLongTermRental ? (
    <FormattedMessage id="BookingBreakdownLongTerm.total" />
  ) : (
    <FormattedMessage id="BookingBreakdown.total" />
  );

  const promoItem = txGetPromoLineItem(transaction);

  const promoAmount = promoItem && !txIsCanceled(transaction) ? promoItem.lineTotal.amount : 0;
  const processingFees = get(
    transaction,
    'attributes.protectedData.commissionObj.commission.processingFees',
    0
  );
  
  const initialPaymentLineItem = transaction.attributes.lineItems.find(
    item => item.code === LINE_ITEM_INITIAL_PAYMENT
  );

  // Also check protectedData.initialPayment as fallback
  const initialPaymentFromProtectedData = transaction.attributes.protectedData.initialPayment;

  const payoutTotal = transaction.attributes.payoutTotal;
  const totalPrice = isProvider
    ? payoutTotal
    : txIsCanceledByCustomer(transaction)
    ? new Money(0, payoutTotal.currency)
    : transaction.attributes.payinTotal;

  // Handle trip modifications by subtracting initial payment when not a trip extension
  // Use line item if available, otherwise use protectedData
  const initialPaymentAmount = initialPaymentLineItem 
    ? Math.abs(initialPaymentLineItem.lineTotal.amount || 0)
    : initialPaymentFromProtectedData 
    ? Math.abs(initialPaymentFromProtectedData)
    : 0;

  const newTotal = !isTripExtension && (initialPaymentLineItem || initialPaymentFromProtectedData)
    ? new Money(totalPrice.amount - initialPaymentAmount, totalPrice.currency)
    : totalPrice;

  const finalTotalPrice = isProvider
    ? new Money(totalPrice.amount - (promoAmount || 0), totalPrice.currency)
    : newTotal;

    let finalUpdatedPrice = finalTotalPrice;
    console.log("Heelo", finalTotalPrice, totalPrice)

  // Add open invoices total if it exists
  if (openInvoicesTotal && openInvoicesTotal.amount) {
    finalUpdatedPrice = new Money(
      finalUpdatedPrice.amount + openInvoicesTotal.amount,
      finalUpdatedPrice.currency
    );
  }

  const formattedTotalPrice = formatMoney(intl, finalUpdatedPrice, 1);

  const hostCredits =
    !isProvider || !currentUser || !currentUser.attributes
      ? 0
      : currentUser.attributes.credits
      ? currentUser.attributes.credits
      : 0;

  const hostCreditMoney =
    !hostCredits || hostCredits < 20
      ? null
      : formatMoney(intl, new Money(2000, totalPrice.currency), 1);
  return (
    <div className={css.lineItemTotal}>
      <div className={css.totalPrice}>{formattedTotalPrice}</div>
    </div>
  );
};

LineItemTotalPriceNew.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTotalPriceNew;
